import { render, staticRenderFns } from "./title_2.vue?vue&type=template&id=0fa5d58f&scoped=true"
import script from "./title_2.vue?vue&type=script&lang=js"
export * from "./title_2.vue?vue&type=script&lang=js"
import style0 from "./title_2.vue?vue&type=style&index=0&id=0fa5d58f&prod&scoped=true&lang=scss"
import style1 from "./title_2.vue?vue&type=style&index=1&id=0fa5d58f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5d58f",
  null
  
)

export default component.exports